export default "__VITE_ASSET__711352c6__"